<template>
  <div>
    <transition name="v-fade" mode="out-in">
        <slot v-if="dataIsLoaded" :response-data="responseData"></slot>
        <div v-else class="spinner"></div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["endpoint", "arrayKey", 'initialSearch'],
  data() {
    return {
      dataIsLoaded: false,
      responseData: null,
      searchString: ''
    };
  },
  mounted() {
    this.searchString = this.initialSearch;
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.dataIsLoaded = false;  
      fetch(this.endpoint + (this.searchString ? '&q=' + this.searchString : ''))
        .then(res => res.json())
        .then(json => {
          if (this.arrayKey) {
            this.responseData = json[this.arrayKey];
          } else {
            this.responseData = json;
          }
          this.dataIsLoaded = true;
        });
    }
  }
};
</script>

<style lang="scss">
</style>

